import React from 'react';
import Button from './button';

class SearchButton extends React.Component {

    render () {
        return (
            <Button className={['component-search-button', 'search-module', this.props.className].join(' ')} type="submit"><span className="icon-desktop-search form-control"></span></Button>
        )
    }
}

export default SearchButton;



// WEBPACK FOOTER //
// ./web-app/components/search-button.jsx